import React from 'react';
import './admin-news-listing-with-filters/news-listing-with-filters.styles.scss';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useDispatch, useSelector } from 'react-redux';
import {
  activePageNumber,
  getAdminPageWiseNews,
  getPageWiseNews,
  loadNews,
} from '../../redux/news/news.action';
import AdminResourceListing from './admin-resource-listing/admin-resource-listing.component';
import AdminNewsListingWithCommonFilters from './admin-news-listing-with-filters/admin-news-listing-with-filters.component';
import AdminNewsAdvanceFilters from './admin-news-listing-with-filters/admin-news-advance-filter.component';

// RP #Task 106 News Landing
function AdminNewsListingWithFilters() {
  const [postsPerPage, setPostPerPage] = React.useState({});

  const dispatch = useDispatch();
  const newsList = useSelector(({ news }) => news.newsList);
  const totalItemsCount = useSelector(({ news }) => news.totalItemsCount);
  const newsLoading = useSelector(({ news }) => news.newsLoading);
  const newsFilter = useSelector(({ news }) => news.filterList);
  const activePage = useSelector(({ news }) => news.pagenumber);

  const ptags = useSelector(({ news }) => news.tagsFilter);
  const pnews = useSelector(({ news }) => news.newsFilter);
  const pindustry = useSelector(({ news }) => news.industryFilter);
  const pdate = useSelector(({ news }) => news.publishedDateFilter);
  const plocation = useSelector(({ news }) => news.locationFilter);

  const publishedDate = [
    {
      Name: 'Past 30 Days',
      Id: '1',
    },
    {
      Name: 'Past 60 Days',
      Id: '2',
    },
    {
      Name: 'Past 90 Days',
      Id: '3',
    },
    {
      Name: 'Past 6 Months',
      Id: '4',
    },
    {
      Name: 'Past 9 Months',
      Id: '5',
    },
    {
      Name: 'Past 12 Months',
      Id: '6',
    },
  ];

  const handlePageChange = (pageNumber) => {
    const selecttags = [];
    const selectnews = [];
    const selectindustry = [];
    const selectlocation = [];
    const selectdate = [];

    ptags.map((item) => {
      selecttags.push(item.Name);
    });
    pnews.map((item) => {
      selectnews.push(item.Id);
    });
    pindustry.map((item) => {
      selectindustry.push(item.Id);
    });
    plocation.map((item) => {
      selectlocation.push(item.Id);
    });
    pdate.map((item) => {
      selectdate.push(item.Id);
    });

    const submissionObj = {
      PageNumber: pageNumber,
      Tags: selecttags,
      NewsCategory: selectnews,
      IndustryCategory: selectindustry,
      Location: selectlocation,
      PublishedDate: selectdate,
    };

    dispatch(loadNews(true));
    dispatch(getAdminPageWiseNews(submissionObj));
    dispatch(activePageNumber(pageNumber));
  };

  return (
    <div className="outer-wrapper module-spacer-bottom sm-up-module-spacer-top">
      <Row className="no-gutter-around xs-only-trinity-container">
        <Col xs={12} sm={8}>
          <div className="wrapper">
            <AdminResourceListing
              newsLoading={newsLoading}
              newsList={newsList}
              postsPerPage={postsPerPage}
              totalItemsCount={totalItemsCount}
              activePage={activePage}
              handlePageChange={handlePageChange}
            />
          </div>
        </Col>

        <Col xs={12} sm={4}>
          <AdminNewsAdvanceFilters
            dataSource={newsFilter.payload.data}
            publishedDateSource={publishedDate}
          />
        </Col>
      </Row>
    </div>
  );
}

export default AdminNewsListingWithFilters;
